import {styled} from "@mui/material/styles"
import {Button as MUIButton, Typography, Link, Drawer as MUIDrawer} from "@mui/material"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"
import {COUNTRY_SELECTOR_DRAWER_BREAKPOINT} from "../../../../config/constants"

export const CountrySelectorContainer = styled("div")`
    display: flex;
    flex-direction: column;
    background: ${({theme}) => theme.uxfabric.background.paper};
    height: 21.75rem;
    width: 100%;
    @media (min-width: ${COUNTRY_SELECTOR_DRAWER_BREAKPOINT}) {
        height: 100%;
    }
`

export const CountrySelectorContainerHeader = styled("div")`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 1rem;
    min-height: 2.75rem;
    background: ${({theme}) => theme.uxfabric.components.card.cardHeader.default.backgroundColor};
`

export const CountrySelectorContainerElement = styled("div")`
    font-size: 14px;
    display: flex;
    flex-direction: column;
    padding: 0.5rem 1rem 0;
    @media (min-width: ${COUNTRY_SELECTOR_DRAWER_BREAKPOINT}) {
        padding: 0.5rem 1rem;
    }
    p {
        margin-bottom: 0.5rem;
    }
`

export const CountrySelectorCTAWrapper = styled("div")`
    display: flex;
    margin: 1rem;
    height: 2.75rem;
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY};
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    @media (min-width: ${breakpoints.values.md}px) {
        height: 2.25rem;
    }
    span {
        line-height: normal;
    }
`

export const LanguageButtonsContainer = styled("div")`
    display: flex;
    justify-content: space-between;

    & > button:nth-of-type(2) {
        margin-left: 0.5rem;
    }
`

export const StyledIcon = styled("img")<{textAlignment?: string}>`
    transform: ${({textAlignment}) => `rotate(${textAlignment === "rtl" ? "90" : "270"}deg)`};
    margin: -0.125rem 0 0 0.25rem;
    top: 0;
`

export const CloseButton = styled(MUIButton)`
    && {
        min-width: 4.5rem;
        background: ${({theme}) => theme.uxfabric.components.card.cardHeader.default.backgroundColor};
        color: ${({theme}) => theme.uxfabric.components.link.primary.enabled.textColor};
        font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
        border-radius: 0;
        border: 0;
        text-transform: none;

        &:hover,
        &:active {
            border: 0;
        }

        &:focus {
            border: 0;
            border-radius: 0;
        }
        span {
            font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
        }
    }
`

export const Title = styled(Typography)`
    color: ${({theme}) => theme.uxfabric.text.primary};
    width: 100%;
    font-size: ${({theme}) => theme.uxfabric.global.subtitle2.fontSize};
    font-family: ${({theme}) => `${theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    letter-spacing: ${({theme}) => theme.uxfabric.global.subtitle2.letterSpacing};
    line-height: ${({theme}) => theme.uxfabric.global.subtitle2.lineHeight};
    text-transform: ${({theme}) => theme.uxfabric.global.subtitle2.textTransform};
`

export const StayText = styled(Typography)`
    && {
        color: ${({theme}) => theme.uxfabric.components.link.primary.enabled.textColor};
        font-weight: ${({theme}) => theme.uxfabric.global.caption.fontWeight};
        padding-right: 0.25rem;
    }
`.withComponent("span")

export const CountrySelectorBottomText = styled("div")`
    display: flex;
    justify-content: flex-end;
    padding: 0.25rem 1rem 0;
`

export const StayButton = styled("button")`
    cursor: pointer;
    background-color: transparent;
    border: none;
    &:active {
        background-color: transparent;
        border: none;
    }
`

export const CountrySelectorROW = styled("div")`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0 0.5rem;
    line-height: 1.25rem;
    && a {
        font-size: 0.875rem;
    }
`

export const LanguageButton = styled("button")<{selected?: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${({theme}) => theme.uxfabric.text.primary};
    border: ${({theme, selected}) =>
        selected
            ? `0.125rem solid ${theme.uxfabric.components.toggleButton.selected.default.borderColor}`
            : `0.125rem solid ${theme.uxfabric.action.default.enabled.borderColor}`};
    background: ${({theme, selected}) =>
        selected
            ? theme.uxfabric.components.toggleButton.selected.default.backgroundColor
            : theme.uxfabric.action.default.enabled.backgroundColor};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    border-radius: ${({theme}) => theme.uxfabric.shape.global.toggleButton.large.borderRadius};

    font-family: ${({theme}) => `${theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    width: calc((100% - 1rem) / 2);
    height: 2.75rem;
    font-size: 14px;
    @media (min-width: ${breakpoints.values.md}px) {
        height: 2.25rem;
        border-radius: ${({theme}) => theme.uxfabric.shape.global.toggleButton.medium.borderRadius};
    }
    cursor: pointer;
    &:focus {
        outline: none;
    }
`
export const CountrySelectorLink = styled(Link)`
    color: ${({theme}) => theme.uxfabric.components.link.primary.enabled.textColor};
    text-decoration-color: inherit;
`
export const DrawerContainer = styled(MUIDrawer)`
    position: initial;
    && > div:first-of-type {
        background: ${({theme}) => theme.uxfabric.components.backdrop.default.backgroundColor};
    }

    && > div:nth-of-type(3) {
        overflow-y: initial;
        width: 100%;
        @media (min-width: ${COUNTRY_SELECTOR_DRAWER_BREAKPOINT}) {
            overflow-y: auto;
            width: 30rem;
        }
    }
`
